import { z } from 'zod';

export const PlatformHealthSchema = z.object({
  totalTenants: z.number(),
  activeTenants: z.number(),
  totalEmployees: z.number(),
  recentPayrollRuns: z.number(),
  generatedAt: z.string(),
});

export type PlatformHealth = z.infer<typeof PlatformHealthSchema>;
